// extracted by mini-css-extract-plugin
export default {"tableResponsive":"Table_tableResponsive__iJFu4","table":"Table_table__U6MvI"};